import { Pipe, PipeTransform } from "@angular/core";
import { NgbTime } from "@ng-bootstrap/ng-bootstrap/timepicker/ngb-time";
import * as moment from 'moment';

@Pipe({ name: 'ngbTime' })
export class NgbTimePipe implements PipeTransform {
    transform(value: NgbTime): string {
        let date = moment().set('hour', value.hour).set('minute', value.minute);

        return date.format("HH:mm");
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/ngb-time.pipe.ts